<template>
  <b-modal
    v-model="modal"
    header-class="mc-modal-header"
    cancel-variant="outline-primary"
    :footer-class="`mc-modal-footer ${footerClass}`"
    :title="title"
    :size="size"
    :ok-title="okTitle"
    :cancel-title="cancelTitle"
    :hide-header="hideHeader"
    :body-class="bodyClass"
    :ok-only="okOnly"
    :centered="centered"
    :no-close-on-backdrop="noCloseOnBackdrop"
    :no-close-on-esc="noCloseOnEsc"
    :ok-disabled="okDisabled"
    @cancel="handleCancel"
    @ok="$emit('handle-ok', $event)"
  >
    <i
      v-if="bodyIcon"
      class="mb-3 display-4 fas"
      :class="icon?.[bodyIcon]" 
    />
    <p
      v-if="bodyTitle"
      :class="`mb-2 font-weight-bold h5 text-${bodyTitleVariant}`"
    >
      {{ bodyTitle }}
    </p>
    <div v-if="bodyTitleDivider" class="mc-divider my-2"></div>
    <div v-if="message" :class="{ 'mb-3': $slots?.default }">{{ message }}</div>
    <slot></slot>
  </b-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String,
      require: true
    },
    message: {
      type: String,
      require: true
    },
    size: {
      type: String,
      default: 'md'
    },
    bodyTitle: {
      type: String,
      require: true
    },
    bodyTitleVariant: {
      type: String
    },
    bodyTitleDivider: {
      type: Boolean
    },
    bodyClass: {
      type: String
    },
    footerClass: {
      type: String
    },
    hideHeader: {
      type: Boolean
    },
    okOnly: {
      type: Boolean
    },
    okTitle: {
      type: String,
      default: 'Terapkan'
    },
    okDisabled: {
      type: Boolean,
      default: false,
    },
    cancelTitle: {
      type: String,
      default: 'Batal'
    },
    bodyIcon: {
      type: String
    },
    centered: {
      type: Boolean,
      default: false,
    },
    'noCloseOnBackdrop': {
      type: Boolean,
      default: false,
    },
    'noCloseOnEsc': {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value', 'handle-ok', 'cancel'],
  data() {
    return {
      icon: {
        'success': 'fa-check-circle text-success',
        'warning': 'fa-exclamation-circle text-warning' 
      }
    }
  },
  computed: {
    modal: {
      set(val) {
        this.$emit('update:value', val)
      },
      get() {
        return this.value
      }
    }
  },
  methods: {
    handleCancel() {
      this.modal = false
      this.$emit('cancel')
    },
  },
}
</script>
<style lang="scss">
.mc-modal-header .close {
  display: none;
}
.mc-modal-footer {
  border-top: none !important;
}
.mc-divider {
  border-bottom: 1px solid #EBECEF;
}
</style>